<script>
  export default {
    props: {
      item: Object,
      relatorio: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data() {
      return {
        configuracao: this.$storage.configuracao()
      }
    },
    methods: {
    }
  }
</script>

<template>
    <div>
        <dl>
            <dt>Tipo de compra</dt>
            <dd>Contratação de Serviços</dd>
        </dl>

        <dl v-if="item.projetoMetaEtapa !== null">
            <dt>Meta etapa</dt>
            <dd>{{ `${item.projetoMetaEtapa.meta.nome} - ${item.projetoMetaEtapa.etapa.nome}` }}</dd>
        </dl>

        <div class="row" v-if="item.rubrica !== null">
            <dl class="col-xs-6">
                <dt>Rubrica</dt>
                <dd>{{ item.rubrica.nome }}</dd>
            </dl>

            <dl class="col-xs-6">
                <dt>Subrubrica</dt>
                <dd>{{ item.subrubrica.nome }}</dd>
            </dl>
        </div>

        <div class="row" v-if="item.idTipoProduto > 0">
            <dl class="col-xs-12">
                <dt>Tipo de produto</dt>
                <dd>{{ item.tipoProduto ? item.tipoProduto.nomeTipoProduto : "---" }}</dd>
            </dl>
        </div>

        <div class="row" v-if="item.idProduto > 0">
            <dl class="col-xs-12">
                <dt>Produto</dt>
                <dd>{{ item.produto ? item.produto.nome : "---" }}</dd>
            </dl>
        </div>

        <div class="row">
            <dl :class="{'col-xs-4': configuracao.utilizarValorEstimado && configuracao.mostrarUnidadeSolicitacaoCompraItemServicos, 'col-xs-6': configuracao.utilizarValorEstimado || configuracao.mostrarUnidadeSolicitacaoCompraItemServicos, 'col-xs-12': !configuracao.utilizarValorEstimado && !configuracao.mostrarUnidadeSolicitacaoCompraItemServicos}">
                <dt>Quantidade</dt>
                <dd>{{ item.quantidade | fixar2digitos }}</dd>
            </dl>

            <dl :class="{'col-xs-4': configuracao.utilizarValorEstimado, 'col-xs-6': !configuracao.utilizarValorEstimado}"
                v-if="configuracao.mostrarUnidadeSolicitacaoCompraItemServicos">
                <dt>Unidade</dt>
                <dd>{{ item.unidade }}</dd>
            </dl>

            <dl :class="{'col-xs-4': configuracao.mostrarUnidadeSolicitacaoCompraItemServicos, 'col-xs-6': !configuracao.mostrarUnidadeSolicitacaoCompraItemServicos}"
                v-if="configuracao.utilizarValorEstimado">
                <dt>Valor estimado</dt>
                <dd>R$ {{ item.valorEstimado | fixar2digitos }}</dd>
            </dl>
        </div>

        <dl>
            <dt>Nome do prestador do serviço</dt>
            <dd>{{ item.nomePrestador || '---' }}</dd>
        </dl>

        <div class="row">
            <dl class="col-sm-6">
                <dt>Telefone</dt>
                <dd>{{ item.telefonePrestador || '---' }}</dd>
            </dl>

            <dl class="col-sm-6">
                <dt>E-mail</dt>
                <dd>{{ item.emailPrestador || '---' }}</dd>
            </dl>
        </div>

        <div class="row">
            <dl class="col-sm-6">
                <dt>Contrato?</dt>
                <dd>{{ item.contrato ? 'Sim' : 'Não'}}</dd>
            </dl>
            <dl class="col-sm-6">
                <dt>Aditivo?</dt>
                <dd>{{ item.aditivo ? 'Sim' : 'Não'}}</dd>
            </dl>
        </div>

        <dl>
            <dt>Descrição do material/serviço</dt>
            <dd class="white-space-pre">{{ item.descricao }}</dd>
        </dl>

        <dl v-if="!configuracao.solCompraOcultarObservacoes">
            <dt>Observação do item de compra</dt>
            <dd class="white-space-pre">{{ item.observacaoItemCompra || '---' }}</dd>
        </dl>

        <dl>
            <dt>Objetivo/Justificativa da compra</dt>
            <dd class="white-space-pre">{{ item.objetivoCompra || '---' }}</dd>
        </dl>

        <dl>
            <dt>Local da prestação de serviço</dt>
            <dd class="white-space-pre">{{ item.localAlocado || '---' }}</dd>
        </dl>
    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-compra/componentes/compartilhado/FormListaContratacaoDeServicos.vue